export default {"src":"/_next/static/media/uncheck_tick_icon.3d3d0a62.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};